/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ISHONCH Platform API
 * Login: POST /api/v1/auth/otp → code (dev: in the app log) → POST /api/v1/auth/otp/verify → paste response_data.as_access_token into Authorize. Every response is the company envelope (ADR-0007).
 * OpenAPI spec version: v1
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CategoryDetailsResponse,
  CategoryResponse,
  FacetsParams,
  FacetsResponse,
  PopularParams,
  ProductCardResponse,
  ProductCardResponsePage,
  ProductDetailsResponse,
  ProductReviewsParams,
  ProductsParams,
  ReviewResponsePage,
} from "../iSHONCHPlatformAPI.schemas";

import { httpRequest } from "../../http";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getCategoriesUrl = () => {
  return `/api/v1/catalog/categories`;
};

export const categories = async (
  options?: Parameters<typeof httpRequest>[1],
): Promise<CategoryResponse[]> => {
  return httpRequest<CategoryResponse[]>(getCategoriesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getCategoriesQueryKey = () => {
  return [`/api/v1/catalog/categories`] as const;
};

export const getCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof categories>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof categories>>, TError, TData>>;
  request?: SecondParameter<typeof httpRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCategoriesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof categories>>> = ({ signal }) =>
    categories({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof categories>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof categories>>>;
export type CategoriesQueryError = unknown;

export function useCategories<TData = Awaited<ReturnType<typeof categories>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof categories>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof categories>>,
          TError,
          Awaited<ReturnType<typeof categories>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCategories<TData = Awaited<ReturnType<typeof categories>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof categories>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof categories>>,
          TError,
          Awaited<ReturnType<typeof categories>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCategories<TData = Awaited<ReturnType<typeof categories>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof categories>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useCategories<TData = Awaited<ReturnType<typeof categories>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof categories>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCategoriesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCategoryUrl = (slug: string) => {
  return `/api/v1/catalog/categories/${slug}`;
};

export const category = async (
  slug: string,
  options?: Parameters<typeof httpRequest>[1],
): Promise<CategoryDetailsResponse> => {
  return httpRequest<CategoryDetailsResponse>(getCategoryUrl(slug), {
    ...options,
    method: "GET",
  });
};

export const getCategoryQueryKey = (slug: string) => {
  return [`/api/v1/catalog/categories/${slug}`] as const;
};

export const getCategoryQueryOptions = <
  TData = Awaited<ReturnType<typeof category>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof category>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCategoryQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof category>>> = ({ signal }) =>
    category(slug, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: slug !== null && slug !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof category>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type CategoryQueryResult = NonNullable<Awaited<ReturnType<typeof category>>>;
export type CategoryQueryError = unknown;

export function useCategory<TData = Awaited<ReturnType<typeof category>>, TError = unknown>(
  slug: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof category>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof category>>,
          TError,
          Awaited<ReturnType<typeof category>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCategory<TData = Awaited<ReturnType<typeof category>>, TError = unknown>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof category>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof category>>,
          TError,
          Awaited<ReturnType<typeof category>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCategory<TData = Awaited<ReturnType<typeof category>>, TError = unknown>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof category>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useCategory<TData = Awaited<ReturnType<typeof category>>, TError = unknown>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof category>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCategoryQueryOptions(slug, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getFacetsUrl = (params?: FacetsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter[brand]", "filter[availability]", "filter[spec]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? "null" : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/catalog/facets?${stringifiedParams}`
    : `/api/v1/catalog/facets`;
};

export const facets = async (
  params?: FacetsParams,
  options?: Parameters<typeof httpRequest>[1],
): Promise<FacetsResponse> => {
  return httpRequest<FacetsResponse>(getFacetsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getFacetsQueryKey = (params?: FacetsParams) => {
  return [`/api/v1/catalog/facets`, ...(params ? [params] : [])] as const;
};

export const getFacetsQueryOptions = <TData = Awaited<ReturnType<typeof facets>>, TError = unknown>(
  params?: FacetsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof facets>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFacetsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof facets>>> = ({ signal }) =>
    facets(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof facets>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FacetsQueryResult = NonNullable<Awaited<ReturnType<typeof facets>>>;
export type FacetsQueryError = unknown;

export function useFacets<TData = Awaited<ReturnType<typeof facets>>, TError = unknown>(
  params: undefined | FacetsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof facets>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof facets>>,
          TError,
          Awaited<ReturnType<typeof facets>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFacets<TData = Awaited<ReturnType<typeof facets>>, TError = unknown>(
  params?: FacetsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof facets>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof facets>>,
          TError,
          Awaited<ReturnType<typeof facets>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFacets<TData = Awaited<ReturnType<typeof facets>>, TError = unknown>(
  params?: FacetsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof facets>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useFacets<TData = Awaited<ReturnType<typeof facets>>, TError = unknown>(
  params?: FacetsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof facets>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFacetsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getProductsUrl = (params?: ProductsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter[brand]", "filter[availability]", "filter[spec]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? "null" : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/catalog/products?${stringifiedParams}`
    : `/api/v1/catalog/products`;
};

export const products = async (
  params?: ProductsParams,
  options?: Parameters<typeof httpRequest>[1],
): Promise<ProductCardResponsePage> => {
  return httpRequest<ProductCardResponsePage>(getProductsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getProductsQueryKey = (params?: ProductsParams) => {
  return [`/api/v1/catalog/products`, ...(params ? [params] : [])] as const;
};

export const getProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof products>>,
  TError = unknown,
>(
  params?: ProductsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof products>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getProductsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof products>>> = ({ signal }) =>
    products(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof products>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ProductsQueryResult = NonNullable<Awaited<ReturnType<typeof products>>>;
export type ProductsQueryError = unknown;

export function useProducts<TData = Awaited<ReturnType<typeof products>>, TError = unknown>(
  params: undefined | ProductsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof products>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof products>>,
          TError,
          Awaited<ReturnType<typeof products>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useProducts<TData = Awaited<ReturnType<typeof products>>, TError = unknown>(
  params?: ProductsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof products>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof products>>,
          TError,
          Awaited<ReturnType<typeof products>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useProducts<TData = Awaited<ReturnType<typeof products>>, TError = unknown>(
  params?: ProductsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof products>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useProducts<TData = Awaited<ReturnType<typeof products>>, TError = unknown>(
  params?: ProductsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof products>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getProductsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getPopularUrl = (params?: PopularParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/catalog/products/popular?${stringifiedParams}`
    : `/api/v1/catalog/products/popular`;
};

export const popular = async (
  params?: PopularParams,
  options?: Parameters<typeof httpRequest>[1],
): Promise<ProductCardResponse[]> => {
  return httpRequest<ProductCardResponse[]>(getPopularUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getPopularQueryKey = (params?: PopularParams) => {
  return [`/api/v1/catalog/products/popular`, ...(params ? [params] : [])] as const;
};

export const getPopularQueryOptions = <
  TData = Awaited<ReturnType<typeof popular>>,
  TError = unknown,
>(
  params?: PopularParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof popular>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPopularQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof popular>>> = ({ signal }) =>
    popular(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof popular>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PopularQueryResult = NonNullable<Awaited<ReturnType<typeof popular>>>;
export type PopularQueryError = unknown;

export function usePopular<TData = Awaited<ReturnType<typeof popular>>, TError = unknown>(
  params: undefined | PopularParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof popular>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof popular>>,
          TError,
          Awaited<ReturnType<typeof popular>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePopular<TData = Awaited<ReturnType<typeof popular>>, TError = unknown>(
  params?: PopularParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof popular>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof popular>>,
          TError,
          Awaited<ReturnType<typeof popular>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePopular<TData = Awaited<ReturnType<typeof popular>>, TError = unknown>(
  params?: PopularParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof popular>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePopular<TData = Awaited<ReturnType<typeof popular>>, TError = unknown>(
  params?: PopularParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof popular>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPopularQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getProductUrl = (slug: string) => {
  return `/api/v1/catalog/products/${slug}`;
};

export const product = async (
  slug: string,
  options?: Parameters<typeof httpRequest>[1],
): Promise<ProductDetailsResponse> => {
  return httpRequest<ProductDetailsResponse>(getProductUrl(slug), {
    ...options,
    method: "GET",
  });
};

export const getProductQueryKey = (slug: string) => {
  return [`/api/v1/catalog/products/${slug}`] as const;
};

export const getProductQueryOptions = <
  TData = Awaited<ReturnType<typeof product>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof product>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getProductQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof product>>> = ({ signal }) =>
    product(slug, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: slug !== null && slug !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof product>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type ProductQueryResult = NonNullable<Awaited<ReturnType<typeof product>>>;
export type ProductQueryError = unknown;

export function useProduct<TData = Awaited<ReturnType<typeof product>>, TError = unknown>(
  slug: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof product>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof product>>,
          TError,
          Awaited<ReturnType<typeof product>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useProduct<TData = Awaited<ReturnType<typeof product>>, TError = unknown>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof product>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof product>>,
          TError,
          Awaited<ReturnType<typeof product>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useProduct<TData = Awaited<ReturnType<typeof product>>, TError = unknown>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof product>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useProduct<TData = Awaited<ReturnType<typeof product>>, TError = unknown>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof product>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getProductQueryOptions(slug, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getProductReviewsUrl = (slug: string, params?: ProductReviewsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/catalog/products/${slug}/reviews?${stringifiedParams}`
    : `/api/v1/catalog/products/${slug}/reviews`;
};

export const productReviews = async (
  slug: string,
  params?: ProductReviewsParams,
  options?: Parameters<typeof httpRequest>[1],
): Promise<ReviewResponsePage> => {
  return httpRequest<ReviewResponsePage>(getProductReviewsUrl(slug, params), {
    ...options,
    method: "GET",
  });
};

export const getProductReviewsQueryKey = (slug: string, params?: ProductReviewsParams) => {
  return [`/api/v1/catalog/products/${slug}/reviews`, ...(params ? [params] : [])] as const;
};

export const getProductReviewsQueryOptions = <
  TData = Awaited<ReturnType<typeof productReviews>>,
  TError = unknown,
>(
  slug: string,
  params?: ProductReviewsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof productReviews>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getProductReviewsQueryKey(slug, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof productReviews>>> = ({ signal }) =>
    productReviews(slug, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: slug !== null && slug !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof productReviews>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type ProductReviewsQueryResult = NonNullable<Awaited<ReturnType<typeof productReviews>>>;
export type ProductReviewsQueryError = unknown;

export function useProductReviews<
  TData = Awaited<ReturnType<typeof productReviews>>,
  TError = unknown,
>(
  slug: string,
  params: undefined | ProductReviewsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof productReviews>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof productReviews>>,
          TError,
          Awaited<ReturnType<typeof productReviews>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useProductReviews<
  TData = Awaited<ReturnType<typeof productReviews>>,
  TError = unknown,
>(
  slug: string,
  params?: ProductReviewsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof productReviews>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof productReviews>>,
          TError,
          Awaited<ReturnType<typeof productReviews>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useProductReviews<
  TData = Awaited<ReturnType<typeof productReviews>>,
  TError = unknown,
>(
  slug: string,
  params?: ProductReviewsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof productReviews>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useProductReviews<
  TData = Awaited<ReturnType<typeof productReviews>>,
  TError = unknown,
>(
  slug: string,
  params?: ProductReviewsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof productReviews>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getProductReviewsQueryOptions(slug, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
